import Translate from 'src/components/Translate/Translate.component';
import { ListTableRemodulationRequests } from 'src/pages/remodulationRequests/RemodulationRequests.types';
import React from 'react';
import colors from 'src/style-utils/colors';
import { P, PSmall } from 'src/style-utils/typographic';
import { StyleSheetManager } from 'styled-components';
import { shouldForwardProp } from 'src/style-utils/functions';

const OrderIdColumn: React.FC<ListTableRemodulationRequests> = ({
  OrderId,
  BuyerName,
}) => {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <div>
        <PSmall textColor={colors.textTableLightBody}>
          <Translate id="remodulationRequestTableColumn.OrderId" />
          {OrderId}
        </PSmall>
        <P textColor={colors.textTableBody}>{BuyerName}</P>
      </div>
    </StyleSheetManager>
  );
};

export default OrderIdColumn;
